// extracted by mini-css-extract-plugin
export var card = "_lw-5";
export var cardSelected = "_lw-4";
export var image = "_lw-3";
export var modal = "_lw-0";
export var modalContent = "_lw-1";
export var table = "_lw-2";